


















import { defineComponent, getCurrentInstance } from '@vue/composition-api';
import { ChevronRightIcon } from 'tdesign-icons-vue';
import i18n, { i18n_t } from '@/locales/i18n';
export default defineComponent({
  name: 'Cell',
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: i18n_t('标题'),
    },
    description: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: i18n_t('请选择'),
    },
    value: {
      type: String,
      default: '',
    },
  },
  components: {
    ChevronRightIcon,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const methods = {
      onClick() {
        context.emit('click');
      },
    };
    return {
      ...methods,
    };
  },
});
